/* eslint-disable no-undef */

'use strict';

/**
 * @description create Subscription
 * @returns {void}
 */

module.exports = {
    createSubscription: function () {
        $(document).ready(function () {
            /**
            * Validates the format of an email address using a regular expression.
            *
            * @param {string} email - The email address to be validated.
            * @returns {boolean} - Returns true if the email address is in a valid format, otherwise false.
            */
            function validateEmail(email) {
                let regex = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
                return regex.test(email);
            }

            /**
             * Builds a full URL by appending query parameters.
             *
             * @param {string} baseUrl - The base URL (absolute or relative) to which query params will be added.
             * @param {Object} params - Optional key-value pairs to append as query parameters.
             * @returns {string|null} - Fully constructed URL with query string or null.
             */
            function buildUrl(baseUrl, params) {
                // early return
                if (!baseUrl) return null;

                const url = new URL(baseUrl, window.location.origin);

                if (params && typeof params === 'object') {
                    Object.entries(params).forEach(([key, value]) => {
                        url.searchParams.set(key, value);
                    });
                }

                return url.toString();
            }

            /**
             * @description Does a subscription call
             * @param {string} email , subscriber email
             */
            function sendSubscriptionRequest(email) {
                $.ajax({
                    type: 'POST',
                    url: CleverReachUrls.footerSubscription,
                    data: { emailAddress: email, source: 'footer' },
                    success: function (response) {
                        if (typeof response === 'string') {
                            try {
                                const jsonString = response.match(/{[^}]*"success":\s*(true|false)[^}]*}/);

                                if (jsonString) {
                                    const jsonResponse = JSON.parse(jsonString[0]);

                                    if (jsonResponse.message) {
                                        $('.newsletter-form').addClass('error');
                                        $('.newsletter-form-error').html(jsonResponse.message);
                                    } else {
                                        window.location.href = buildUrl(CleverReachUrls.subscriptionStatus, { status: jsonResponse.status });
                                    }
                                } else {
                                    window.location.href = CleverReachUrls.subscriptionStatus;
                                }
                            } catch (e) {
                                window.location.href = CleverReachUrls.subscriptionStatus;
                            }
                        }
                    },
                    error: function () {
                        window.location.href = CleverReachUrls.subscriptionStatus;
                    }
                });
            }

            $('#cleverReach-newsletter-subscription button').on('click', function (e) {
                e.preventDefault();
                let email = $('#cleverReach-newsletter-subscription #email-alert-address').val();
                $('#cleverReach-newsletter-subscription').find('.newsletter-form.error').removeClass('error');
                if (email.length > 0) {
                    if (validateEmail(email)) {
                        sendSubscriptionRequest(email);
                    } else {
                        $(this).closest('.newsletter-form').addClass('error');
                    }
                }
            });

            // Add a checkbox for privacy policy if cleverReach is enabled
            if (window.CleverReachPreferences && window.CleverReachPreferences.cleverReachEnabled && window.CleverReachPreferences.cleverReachEnabled !== false) {
                let elementBefore = '<input type="checkbox" class="input-checkbox privacy-checkbox" value="false" /> ' + window.CleverReachResources.privacyBeforeLink + ' ';
                let elementAfter = ' ' + window.CleverReachResources.privacyAfterLink;

                $('a.privacy-policy').parent().prepend(elementBefore).append(elementAfter);

                $('#dwfrm_billing').on('submit', function (event) {
                    if ($(this).find('input.privacy-checkbox').prop('checked') === false) {
                        event.preventDefault();
                        $('input.privacy-checkbox').parent().addClass('error-privacy');
                    } else {
                        $('input.privacy-checkbox').parent().removeClass('error-privacy');
                    }
                });
                $('#account_subscribe').on('click', function (event) {
                    event.preventDefault();
                    $('.email-signup-wrapper').slideDown(800);
                });
            }

            $('.js-cleverreach-newsletter-form').on('submit', function (e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                const $form = $(this);
                const url = $form.attr('action');
                const method = $form.attr('method');
                const formData = $form.serialize();

                $form.spinner().start();

                $.ajax({
                    url: url,
                    method: method,
                    data: formData,
                    success: function (response) {
                        if (typeof response === 'string') {
                            try {
                                const jsonString = response.match(/{[^}]*"success":\s*(true|false)[^}]*}/);

                                if (jsonString) {
                                    const jsonResponse = JSON.parse(jsonString[0]);

                                    window.location.href = buildUrl(CleverReachUrls.subscriptionStatus, { status: jsonResponse.status });
                                } else {
                                    window.location.href = CleverReachUrls.subscriptionStatus;
                                }
                            } catch (e) {
                                window.location.href = CleverReachUrls.subscriptionStatus;
                            }
                        } else {
                            window.location.href = buildUrl(CleverReachUrls.subscriptionStatus, { status: response.status });
                        }
                    },
                    error: function () {
                        window.location.href = CleverReachUrls.subscriptionStatus;
                    }
                });
            });
        });
    }
};
